module.exports = __webpack_public_path__ + "plus-2021jump/images/content_campaign2.ceec8df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content_campaign2.jpg
// module id = os9u
// module chunks = 0